import { render, staticRenderFns } from "./Dashboard1.vue?vue&type=template&id=74ee25a0&"
import script from "./Dashboard1.vue?vue&type=script&lang=js&"
export * from "./Dashboard1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports